module.exports = __webpack_public_path__ + "static/media/mdi_chevron-right-circle-outline.03101294.svg";